import { render, staticRenderFns } from "./MoveMachine.vue?vue&type=template&id=4bb803b6&scoped=true"
import script from "./MoveMachine.vue?vue&type=script&lang=js"
export * from "./MoveMachine.vue?vue&type=script&lang=js"
import style0 from "./MoveMachine.vue?vue&type=style&index=0&id=4bb803b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb803b6",
  null
  
)

export default component.exports